import VueI18n from 'vue-i18n';
import Vue from 'vue';

Vue.use(VueI18n);

const messages = {
  uk: {
    donate: {
      title: 'Підтримка проекту',
      text: 'На даний момент проект немає жодних сторонніх інвестицій і розвивається суто завдяки нашому виділеному ' +
        'вільному часу та бажанню створити щось цікаве/перспективне<br>' +
        'Якщо у Вас є можливість допомогти розвитку проекту, або ідеї що до його покращення - звертайтесь в телеграм' +
        ' <a target="_blank" href="https://t.me/atlantik_hak"><b>Другак Іван</b></a>'
    },
    work: 'Робота',
    app_name: 'Free-Time',
    log_in: 'Увійти',
    log_out: 'Вихід',
    about: 'Про проект',
    comment: 'Коментар',
    developers: 'Розробники проекту',
    pub_enterprises: 'Публічні підприємства',
    username: 'Номер телефону або E-mail',
    phone: 'Номер телефону',
    password: 'Пароль',
    password_confirmation: 'Підтвердження пароля',
    forgot_password: 'Забули пароль?',
    code_from_sms: 'Код з смс',
    sign_up: 'Реєстрація',
    get_sms_code: 'Отримати код',
    products_page: 'Товари підприємства',
    blog_page: 'Блог підприємства',
    edit: 'Редагувати',
    save: 'Зберегти',
    close: 'Закрити',
    name: 'Ім\'я',
    last_name: 'Прізвище',
    show: 'Переглянути',
    confirm_privacy_policy: 'Погоджуюсь із політикою конфіденційності.',
    delete: 'Видалити',
    download: 'Завантажити',
    history: 'Історія',
    add: 'Додати',
    add_to_check: 'Додати до чеку',
    add_to_outgoing_invoice: 'Додати вихідної накладної',
    add_to_income_invoice: 'Додати прихідної накладної',
    cancel: 'Скасувати',
    titles: {
      home_page: 'Free-Time: Все для Підприємця та Клієнта'
    },
    product: {
      title: 'Назва товару',
      short_title: 'Коротка назва',
      price: 'Продаж',
      wholesale_price: 'Закупка',
      opt_price: 'Опт',
      big_opt_price: 'Мегаопт',
      measure: 'Од. вимірювання',
      category: 'Група товарів',
      type_category: 'Категорія товарів',
      value: 'Залишок товару',
      photo: 'Фото'
    },
    invoices: {
      received: {
        null: 'Очікується доставка',
        true: 'Товар доставлено',
        false: 'Доставка скасована',
        change_title: 'Змінити статус доставки товару накладної'
      },
      edit_product: {
        title: 'Редагування товару',
        wholesale_price: 'Ціна закупки',
        price: 'Ціна продажу',
        real_value: 'Доставлена кількість'
      },
      add_transferred_cash: 'Додати оплачену суму',
      not_paid: 'Не оплачено',
      paid: 'Оплачено',
      overpaid: 'Переплачено',
      statuses: {
        null: 'Статус не вказано',
        0: 'Отримано на склад',
        1: 'Завантажено',
        2: 'Доставлено'
      }
    },
    cash_registers: {
      item: 'Каса',
      value: 'Сума'
    },
    customers: {
      title: 'Замовник'
    },
    positions: {
      title: 'Посади',
      users: 'Працівники',
      user_empty: 'Посада порожня'
    },
    filter_btn: 'Фільтрувати',
    date_from: 'Від',
    date_to: 'До'
  }
};

export default new VueI18n({
  locale: 'uk',
  messages
});
